import { useEffect, useState } from 'react';
import MainHeader from '../main-header';
import Sidebar from '../sidebar';
import styles from './index.module.css';

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: React.FunctionComponent<MainLayoutProps> = (props: MainLayoutProps) => {
  const [isVisibleMainMenu, setIsVisibleMainMenu] = useState<boolean>(true);
  const [isMobileResolution, setIsMobileResolution] = useState<boolean | undefined>(undefined);
  const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const onWindowResize = (evt: any) => {
      const window = evt.target;
      setInnerWidth(window.innerWidth);
      setIsVisibleMainMenu(true);
    };

    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);

  useEffect(() => {
    if (innerWidth > 767) {
      setIsMobileResolution(false);
      setIsVisibleMainMenu(true);
    } else {
      setIsMobileResolution(true);
      setIsVisibleMainMenu(false);
    }
  }, [innerWidth]);

  const onMainMenuVisibleChange = () => {
    if (innerWidth < 767) {
      setIsVisibleMainMenu((isVisibleMainMenu: boolean) => !isVisibleMainMenu);
    }
  };

  return (
    <div className={styles['main-container-section']}>
      <MainHeader
        onMainMenuVisibleChange={onMainMenuVisibleChange}
        isVisibleMainMenu={isVisibleMainMenu}
        isMobileResolution={isMobileResolution}
      />
      <div className={styles['main-layout-container']}>
        <Sidebar isVisibleMainMenu={isVisibleMainMenu} onMainMenuVisibleChange={onMainMenuVisibleChange} />
        {props.children}
      </div>
    </div>
  );
};

export default MainLayout;
